<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import lodash from 'lodash';
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowPercentNewPatientsOnSlit',
    extends: TableRowBase,
    data() {
      return {
        fields: [
          'num_new_patients_scit',
          'num_new_patients_slit',
        ],
      };
    },
    computed: {
      actualValueRaw() {
        const totalPatients = lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.curMonth[field])
        }, 0);
        return this.round(this.getRatio(parseInt(this.curMonth['num_new_patients_slit']),  totalPatients), 2);
      },
      benchmarkValueRaw() {
        const totalPatients = lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.benchmarkMonth[field])
        }, 0);
        return this.round(this.getRatio(parseInt(this.benchmarkMonth['num_new_patients_slit']), totalPatients), 2);
      },
      previousValueRaw() {
        const totalPatients = lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.prevYearMonth[field])
        }, 0);
        return this.round(this.getRatio(parseInt(this.prevYearMonth['num_new_patients_slit']), totalPatients), 2);
      },
    },
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        const totalPatients = lodash.reduce(this.fields, (sum, field) => {
          return sum + this.getYtdByField(yearObj, field, throughMonth)
        }, 0);
        return this.round(this.getRatio(this.getYtdByField(yearObj, 'num_new_patients_slit', throughMonth), totalPatients), 2);
      },
    },
  };
</script>
